import { Box, BoxProps } from '@mui/material';
import { useEffect, useRef, useState } from 'react';

type StickyUntilVisibleProps = BoxProps & {
  bottom?: number;
  height: number;
};

export const StickyUntilVisible = ({
  children,
  bottom = 0,
  height,
  ...rest
}: StickyUntilVisibleProps) => {
  const realRef = useRef<HTMLDivElement>(null);
  const [isRealVisible, setIsRealVisible] = useState(false);

  useEffect(() => {
    const element = realRef.current;
    if (!element) return;

    const intersectionObserver = new IntersectionObserver(
      ([entry]) => {
        setIsRealVisible(entry.intersectionRatio === 1);
      },
      {
        threshold: [0, 1],
      }
    );

    intersectionObserver.observe(element);

    return () => {
      intersectionObserver.disconnect();
    };
  }, []);

  return (
    <>
      {!isRealVisible && (
        <Box
          style={{
            position: 'fixed',
            left: 0,
            right: 0,
            bottom,
            zIndex: 50,
            height,
          }}
          {...rest}
        >
          {children}
        </Box>
      )}

      <Box
        ref={realRef}
        style={{
          minHeight: height,
        }}
        {...rest}
      >
        {children}
      </Box>
    </>
  );
};
